// extracted by mini-css-extract-plugin
export default {"input-box":"searchFeature_input-box__1s5Eb"};